<template>
    <div id="app" class="flex relative flex-col flex-1 p-4 justify-center items-center " @dragover.prevent
        @drag.prevent>

        <header class="flex flex-row items-center p-4 ">
            <router-link :to="{ name: 'index' }" class="text-gray-500 text-sm mx-4">Úvod</router-link>
            <router-link :to="{ name: 'tech' }" class="text-gray-500 text-sm  mx-4">Technológia</router-link>
            <router-link :to="{ name: 'contact' }" class="text-gray-500 text-sm  mx-4">O nás</router-link>
        </header>

        <div class="flex flex-col flex-1 w-full justify-center items-center ">

            <router-view />

        </div>

        <!-- <facebook-page/> -->


        <!-- <footer class="flex flex-col w-full relative max-w-full overflow-hidden items-center mt-10">

            <div class="w-full hidden md:flex justify-center">
                <div class="fb-like absolute " data-href="https://www.facebook.com/holubnik.sk" data-width="400" data-layout="standard" data-action="like" data-size="small"  data-share="true"></div>
            </div>

            <div class="flex justify-center md:hidden">
                <div class="fb-like" data-href="https://www.facebook.com/holubnik.sk" data-width="300" data-layout="button_count" data-action="like" data-size="small" data-share="true"></div>
            </div>

        </footer> -->

        <cookie-law theme="base--rounded" message="Súhlasím, aby mi koláčiky zlepšovali život." buttonText="Okej"
            v-on:accept="enableTracking()"></cookie-law>

    </div>
</template>

<script>

import CookieLaw from 'vue-cookie-law'
import { enableAnalytics } from '@/assets/js/analytics'

export default {

    name: 'App',

    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'holubnik.sk',
        // all titles will be injected into this template
        titleTemplate: '%s | holubnik.sk',
    },

    components: {
        CookieLaw
    },

    data: function () {
        return {
            device1: 'lnr-laptop',
            device2: 'lnr-smartphone',
        }
    },

    beforeDestroy() {
        clearInterval(this.deviceChanger)
    },

    created() {
        this.deviceChanger()
    },

    mounted() {

    },

    methods: {

        randomDevice() {
            const items = ['lnr-laptop', 'lnr-screen', 'lnr-smartphone', 'lnr-tablet']
            return items[Math.floor(Math.random() * items.length)];
        },

        deviceChanger() {
            this.deviceChager = setInterval(() => {
                this.device1 = this.randomDevice()
                this.device2 = this.randomDevice()
            }, 2000)

        },

        enableTracking() {
            enableAnalytics()
        }
    },
}
</script>

<style></style>
